<template>
  <div>
    <v-alert color="#D3EAFD" light>
      <v-row>
        <v-col cols="12" md="10">
          <v-list-item class="px-0">
            <v-list-item-avatar color="white" size="60">
              <v-icon color="blue">mdi-pencil</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="py-0 px-1">
              <span class="title">Berita Acara</span>
              <div class="">
                Anda diharuskan untuk melakukan verval terhadap berita acara yang telah dibuat
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="2">
          <v-list-item class="px-0">
            <v-list-item-content class="px-1">
              <v-btn
                depressed
                small
                color="info"
                @click="onEdit"
                v-if="currStep === 8 && $allow('psp-peringkat-verval.verval-ba')"
                :disabled="!$allow('psp-peringkat-verval.verval-ba')"
              >
                <v-icon left dark>mdi-pencil</v-icon>
                Verval BA
              </v-btn>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-alert>
    <v-row class="my-2">
      <v-col cols="12" md="7">
        <v-list-item class="px-0">
          <v-list-item-content class="py-0 px-1">
            <div class="title">
              Dokumen Berita Acara Kepala Sekolah yang Lolos
            </div>
            <div class="body-2">
              Merupakan file dokumen resmi yang telah diunggah oleh pihak daerah yang berwenang
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="12" md="3">
        <v-list-item>
          <div>
            <div>
              <span class="caption grey--text">Waktu Unggah</span>
            </div>
            <div class="body-2">
              {{ $localDate((tahap && tahap.wkt_proses) || '-') }}
            </div>
          </div>
        </v-list-item>
      </v-col>
      <v-col cols="12" md="2" v-if="currStep >= 8">
        <v-list-item class="px-0">
          <v-list-item-content class="py-0">
            <v-list-item-title class="mt-5" />
            <v-list-item-subtitle class="link black--text body-2">
              <v-btn depressed small dark color="blue" @click="onBa">
                <v-icon left dark>
                  mdi-eye
                </v-icon>
                Lihat Dokumen
              </v-btn>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="12" class="py-0">
        <v-alert color="#FFF2E6" light class="my-2" v-if="currStep > 8">
          <div class="subtitle-1 font-weight-bold">Tanggapan Anda terkait laporan ini?</div>
          <div class="my-3">
            <v-btn
              :color="WARNA_STATUS[currStep] && WARNA_STATUS[currStep]['color']"
              class="mx-md-1"
              small
              dark
              depressed
            >
              <v-icon left>{{ WARNA_STATUS[currStep] && WARNA_STATUS[currStep]['icon'] }}</v-icon>
              {{ WARNA_STATUS[currStep] && WARNA_STATUS[currStep]['keterangan'] }}
            </v-btn>
          </div>
          <template v-if="currStep === 9">
            <span class="body-2 grey--text">{{ WARNA_STATUS[currStep] && WARNA_STATUS[currStep]['catatanTeks'] }}</span>
            <h3>" {{ tahapPerbaikan.catatan || '-' }} "</h3>
          </template>
        </v-alert>
      </v-col>
    </v-row>
    <v-divider />
    <template v-if="+detail.is_revisi === 1">
      <v-row class="my-2">
        <v-col cols="12" md="7">
          <v-list-item class="px-0">
            <v-list-item-content class="py-0 px-1">
              <div class="title">
                Dokumen Berita Acara Kepala Sekolah yang Lolos <span class="red--text">(REVISI)</span>
              </div>
              <div class="body-2">
                Merupakan file dokumen resmi yang telah diunggah oleh pihak daerah yang berwenang
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="3" v-if="currStep >= 8">
          <v-list-item class="px-0">
            <v-list-item-content class="py-0">
              <v-list-item-title class="mt-5" />
              <v-list-item-subtitle class="link black--text body-2">
                <v-btn
                  depressed
                  small
                  dark
                  color="green"
                  target="_blank"
                  class="text-capitalize"
                  @click="onDownloadTemplate(`${detail.psp_peringkat_id}/ba-template-revisi`)"
                >
                  <v-icon left dark>
                    mdi-download
                  </v-icon>
                  Template BA Revisi
                </v-btn>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="2" v-if="currStep >= 8">
          <v-list-item class="px-0">
            <v-list-item-content class="py-0">
              <v-list-item-title class="mt-5" />
              <v-list-item-subtitle class="link black--text body-2">
                <v-btn
                  depressed
                  small
                  dark
                  color="blue"
                  :href="detail.url_ba_revisi"
                  :disabled="!detail.url_ba_revisi"
                  target="_blank"
                >
                  <v-icon left dark>
                    mdi-eye
                  </v-icon>
                  Lihat Dokumen
                </v-btn>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </template>
    <popup-ba ref="formulir" :detail="detail" @save="onSave"></popup-ba>
  </div>
</template>

<script>
import PopupBa from '@views/instansi/peringkat/verval/formulir/PopupBa';
import { mapActions } from 'vuex';
export default {
  name: 'Kandidat',
  components: { PopupBa },
  props: {
    detail: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      M_STATUS_VERVAL: [10, 9],
      WARNA_STATUS: {
        10: { color: 'success', icon: 'mdi-check', keterangan: 'Dokumen BA sudah sesuai', catatanTeks: 'Saran/Solusi' },
        9: {
          color: 'error',
          icon: 'mdi-close',
          keterangan: 'Dokumen BA belum sesuai, perlu ada perbaikan',
          catatanTeks: 'Catatan untuk Perbaikan Berkas Berita Acara',
        },
      },
    };
  },
  computed: {
    currStep() {
      const tahap = this.detail && this.detail.k_tahap_peringkat_psp;
      return tahap;
    },

    tahap() {
      const tahaps = this.$getDeepObj(this.detail, 'psp_peringkat_tahaps') || [];
      const filtered = tahaps.filter((item) => item.k_tahap_peringkat_psp === 8);
      const idx = filtered.length - 1;
      return (filtered && filtered[idx]) || {};
    },

    tahapPerbaikan() {
      const tahaps = this.$getDeepObj(this.detail, 'psp_peringkat_tahaps') || [];
      const idx = tahaps.findIndex((item) => item.k_tahap_peringkat_psp === 9);
      return tahaps[idx];
    },
  },
  methods: {
    ...mapActions('peringkatVerval', ['fetch', 'action', 'downloadList']),

    onBa() {
      window.open(this.detail && this.detail.url_ba);
    },

    onDownloadTemplate(url) {
      this.downloadList({ url, params: { inline: 1 } }).then((url) => {
        window.open(url, '_blank');
      });
    },

    onEdit() {
      this.$refs.formulir.open();
    },

    onSave(params) {
      this.action({ id: this.detail.psp_peringkat_id, params, aksi: 'verval-ba' }).then(() => {
        this.$emit('reload');
        this.$success('Verval BA berhasil disimpan');
        this.$refs.formulir.close();
      });
    },
  },
};
</script>

<style scoped></style>
